// $(".header__menu-item").on("click", function(event) {
//   event.preventDefault();
//   var targetDiv = $(this).attr("href");
//   $("html, body").animate({
//     scrollTop: $(targetDiv).offset().top
//   }, 800);
// });


document.addEventListener("DOMContentLoaded", function () {
  const $slider = $('.content-block-wrapper');

  function toggleSlick() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile && !$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        speed: 900,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        arrows: true,
        adaptiveHeight: true,
        prevArrow: '<svg class="slick_prev_arrow" fill="#000" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.006 512.006" stroke="#fff"><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0 L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251 c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"></path></svg>',
        nextArrow: '<svg class="slick_next_arrow" fill="#000" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330.002 330.002" stroke="#fff"><path d="M233.252,155.997L120.752,6.001c-4.972-6.628-14.372-7.97-21-3c-6.628,4.971-7.971,14.373-3,21 l105.75,140.997L96.752,306.001c-4.971,6.627-3.627,16.03,3,21c2.698,2.024,5.856,3.001,8.988,3.001 c4.561,0,9.065-2.072,12.012-6.001l112.5-150.004C237.252,168.664,237.252,161.33,233.252,155.997z"></path></svg>'
      });
    } else if (!isMobile && $slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
  // Initial check
  toggleSlick();
  // Recheck on resize
  window.addEventListener('resize', function () {
    toggleSlick();
  });
});


function handleMenuBehavior(e) {
  // Target only details inside the header menu
  const detailsElements = document.querySelectorAll('.header__inline-menu details');

  if (e.matches) {
    // Enable hover behavior
    detailsElements.forEach(details => {
      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);
    });
  } else {
    // Disable hover behavior
    detailsElements.forEach(details => {
      details.removeEventListener('mouseenter', openMenu);
      details.removeEventListener('mouseleave', closeMenu);
      details.removeAttribute('open');
      const menuItem = details.querySelector('.header__menu-item');
      if (menuItem) menuItem.removeAttribute('aria-expanded');
    });
  }

  // --- helper functions ---
  function openMenu() {
    detailsElements.forEach(d => d.removeAttribute('open'));
    this.setAttribute('open', true);
    document.querySelectorAll('header details .header__menu-item')
      .forEach(item => item.removeAttribute('aria-expanded'));
    const menuItem = this.querySelector('.header__menu-item');
    if (menuItem) menuItem.setAttribute('aria-expanded', true);
  }

  function closeMenu() {
    this.removeAttribute('open');
    const menuItem = this.querySelector('.header__menu-item');
    if (menuItem) menuItem.removeAttribute('aria-expanded');
  }
}

// --- Initialize ---
const mediaQuery = window.matchMedia('(min-width: 999px)');
mediaQuery.addEventListener('change', handleMenuBehavior);
document.addEventListener('DOMContentLoaded', () => handleMenuBehavior(mediaQuery));



$(document).ready(function(){
  var accordionContent = $('.product-accordion-answer');
  var accordianHeading = $('.product-accordion-question');
  accordianHeading.click(function(){                         
    accordianHeading.removeClass("open");
    var isOpen = $(this).next().is(":visible");
    accordionContent.slideUp(500);
    if (!isOpen)
    {
      $(this).nextUntil(accordianHeading).slideDown(500);
      $(this).addClass("open");
    }
  });
});

$(document).ready(function(){
  var accordionContent = $('.about-us-accordion-content-block');
  var accordianHeading = $('.about-us-acc-title');
  accordianHeading.click(function(){                         
    accordianHeading.removeClass("open");
    var isOpen = $(this).next().is(":visible");
    accordionContent.slideUp(500);
    if (!isOpen)
    {
      $(this).nextUntil(accordianHeading).slideDown(500);
      $(this).addClass("open");
    }
  });

  $('.header__menu-item.list-menu__item span').on('click', function() {
    var redirect_link = $(this).data('link');
    window.location.href = redirect_link;
  });
});
